<template>
    <div id="users_page" class="container-fluid">
        <template v-if="$store.getters.getAuthUser.original.user_type_id < 2">
            <router-link v-if="has_clients" :to="{ path: '/users/managers' }" class="btn btn-secondary ml-5 main-button pull-right">Project Managers</router-link>
            <router-link v-if="has_clients" :to="{ path: '/users/create' }" class="btn btn-secondary main-button pull-right">+ Add New User</router-link>
        </template>
        <button v-if="!has_clients" class="btn btn-secondary main-button pull-right" style="pointer-events:initial !important;" title="You need at least a client to be able to add a user" disabled>+ Add New User</button>
        <v-client-table :data="tableData" :columns="columns" :options="options">
            <div v-if="$store.getters.getAuthUser.original.user_type_id < 2" slot="actions" slot-scope="props" class="text-right">
                <router-link :to="{ path: `users/edit/${props.row.id}` }" class="btn btn-info reverse">Edit</router-link>
                <button @click="remove(props.row.id)" class="btn btn-danger reverse btn-icon">
                    <i class="fa fa-trash-o" aria-hidden="true"></i>
                </button>
            </div>
        </v-client-table>
    </div>
</template>

<script>
    export default {
        created() {
            this.fetchServerData();
        },
        data() {
            return {
                has_clients:false,
                columns: ['first_name', 'last_name', 'user_type', 'email', 'actions'],
                tableData: [],
                options: {
                    headings: {
                        first_name: 'First Name',
                        last_name:  'Last Name',
                        user_type:  'User Type',
                        email:      'Email',
                        actions:    ''
                    },
                    sortable: ['first_name', 'last_name', 'user_type', 'email'],
                    perPage: 20,
                    perPageValues: [],
                    texts: {
                        count: 'Showing {from} to {to} of {count} users|{count} users|One user',
                        filter: '',
                        filterPlaceholder: 'Search users...',
                        noResults: 'No matching users'
                    },
                    skin: 'table'
                }
            }
        },
        methods: {
            fetchServerData() {
                axios.all([
                    axios.get('/api/clients?with_data=user'),
                    axios.get('/api/users')
                ]).then(axios.spread((clients, users) => {
                    this.tableData  = users.data;
                    this.has_clients = clients.data.length;
                }));
            },
            remove(userId) {
                this.confirmation(this.messages.WARNING_USER_DELETE, () => {
                    axios.delete(`/api/users/${userId}`).then(response => {
                        this.fetchServerData();
                        this.$notify({
                            type: 'success',
                            text: this.messages.USER_DELETED
                        });
                    });
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    #users_page {
        .fa-trash-o {
            font-size: 1.4rem;
            padding: .1rem;
        }

        button:disabled{
            cursor: not-allowed;

            &:hover{
                color:white;
            }
        }
    }
</style>